import {jsx} from 'panel';

import {DISPLAY_TYPE, EmptyReportHeroEl} from './index';

export function SensitiveDataHero({bodyText, reportName}: {bodyText: string; reportName: string}) {
  return (
    <EmptyReportHeroEl
      attrs={{
        type: DISPLAY_TYPE.SENSITIVE,
        report: reportName,
        'header-text': `Report contains classified data`,
        'body-text': bodyText || ``,
      }}
    />
  );
}

export function MissingDataGroupMappingHero({property, reportName}: {property: string; reportName: string}) {
  return (
    <EmptyReportHeroEl
      attrs={{
        type: DISPLAY_TYPE.MISSING_MAPPED_DATAGROUP,
        report: reportName,
        'header-text': `Unable to Display Data`,
      }}
    >
      <span>The property</span>
      <strong>{property}</strong>
      <span>is no longer available for use.</span>
      <div sel='.text'>Please use another property or contact your project admin.</div>
    </EmptyReportHeroEl>
  );
}
